import { render } from "./Properties.vue?vue&type=template&id=755c6cfa&ts=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"

import "./Properties.vue?vue&type=style&index=0&id=755c6cfa&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__